<style lang="less" src="./app.less"></style>
<template>
    <header>
        <section class="content-common-width">
            <div class="content-wrapper">
                <div class="logo-wrapper">
                    <a :href="officialUrl" target="_blank">
                        <img src="./assets/images/logo.png" width="143" height="39" />
                    </a>
                </div>
                <div class="language-wrapper">
                    <GlobalOutlined />
                    <a-select v-model:value="selectedLanguage" style="width: 100px" @change="changeLanguage" :bordered="false">
                        <a-select-option value="zh">简体中文</a-select-option>
                        <a-select-option value="en">English</a-select-option>
                    </a-select>
                </div>
            </div>
        </section>
    </header>
    <main>
        <RouterView />
    </main>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { GlobalOutlined } from '@ant-design/icons-vue';
import { CookieStorage } from '@do/do-auth-web-client';
import { useI18n } from 'vue-i18n';

const { t, locale } = useI18n();
const officialUrl = ref(window.ENV_CONFIG.officialUrl);
const cookieStorage = new CookieStorage();
const selectedLanguage = ref(cookieStorage.getLocaleInfo() || 'zh');
const changeLanguage = (value: string) => {
    selectedLanguage.value = value;
    locale.value = value;
    cookieStorage.setLocaleInfo(value);
};
</script>
